export const educationData = [
    {
        id: 1,
        institution: 'Ramjas College, Delhi University',
        course: 'B.A. Honours History',
        startYear: '2015',
        endYear: '2018'
    },
    {
        id: 2,
        institution: 'Delhi University',
        course: 'M.A. History',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Masai School of Coding',
        course: 'Fullstack Web-Development',
        startYear: '2021',
        endYear: 'Present'
    },
]